import { cn } from "../../../utils/cn";
import { getItemTagLabel } from "../../../utils/help/itemExtras/itemExtras";
import { ItemType } from "../../../utils/types";
import { PChip, PChipSize } from "../PChip/PChip";
import styles from "./ItemTagChip.module.scss";

type ItemTagChipProps = {
  item?: Pick<ItemType, "id" | "tags"> | null;
  /**
   * An unavailable item shows no tag at all — neither on the menu card nor on
   * the item page — so the "Unavailable" chip is never competing with a
   * "Best seller" one.
   */
  isOutOfStock?: boolean;
  size?: PChipSize;
  className?: string;
};

export const ItemTagChip = ({
  item,
  isOutOfStock = false,
  size = "xs",
  className,
}: ItemTagChipProps) => {
  const label = getItemTagLabel(item);

  if (!label || isOutOfStock) {
    return null;
  }

  return (
    <PChip
      filled
      size={size}
      className={cn(styles.item_tag, className)}
      data-testid={`item-tag-${item?.id}`}
    >
      {label}
    </PChip>
  );
};
